<template>
  <v-container fluid>
    <v-row justify="center">
     <v-col cols="12" md="3" lg="3">
        <v-card
          class="elevation-12"
          width="400"
          height="400"
          @click="$router.push('/analytics')"
        >
        </v-card>
     </v-col>

     <v-col cols="12" md="3" lg="3">
        <v-card
          class="elevation-12"
          width="400"
          height="400"
          @click="$router.push('/map')"
        >
        </v-card>
     </v-col>

     <v-col cols="12" md="3" lg="3">
        <v-card
          class="elevation-12"
          width="400"
          height="400"
          @click="$router.push('/map')"
        >
        </v-card>
     </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      isErrorAuth: false,
      username: "",
      password: "",
      wrongCred: false, // activates appropriate message if set to true
    };
  },
};
</script>

<style></style>
